<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <v-btn class="primary" round @click="addFnoItem()">Add Package to Network</v-btn>
      <v-btn class="primary" round @click="addFnoGroup()">Add Package Group to Network</v-btn>
    </v-toolbar>

  <v-dialog persistent v-model="addPackageGroupModal" max-width="1000px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD FNO PACKAGE GROUP</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex>
                  <h3>FNO Package Groups on Network:</h3>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-chip
                    v-for="tag in chosenFnoCats"
                    :key="tag.id"
                    item-text="name"
                    item-value="id"
                  >{{tag.name}}</v-chip>
                </v-flex>
              <v-flex xs8 sm8 md8>
                   <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="packagesfnocats"
                    v-model="selectedFnoCat"
                    item-text="name"
                    item-value="id"
                    label="Select Associated FNO Package Group"
                  >
               </v-autocomplete>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="generateSelectedPackages($route.params.locationNetworkId).then(getPackages());addPackageGroupModal=false"
                    round
                  >Generate FNO Packages</v-btn>
                </v-flex>
              </v-layout>
          </v-container>
          <v-card-actions>
            <v-flex xs12 sm12 md12>
              <v-btn color="primary" round @click="addPackageGroupModal=false">Cancel</v-btn>
            </v-flex>
          
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="addPackageModal" max-width="1000px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD FNO PACKAGE</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
             
      <v-flex xs6 sm3 md3>
          <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="Speed"
                  :items="speedprofiles"
                  item-text="name"
                  item-value="id"
                  v-model="filterSpeed"
                >
               </v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
         <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="Package Type"
                  :items="packagetypes"
                  item-text="name"
                  item-value="name"
                  v-model="filterPackageType"
              >
               </v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-btn flat class="primary" round  @click="filterPackages=true">Apply Filter</v-btn>
      </v-flex>
                <v-container>
              <v-data-table
              :headers="allpackagesfnolocationnetworksheaders"
              class="elevation-1"
              :items="allpackagesfnolocationnetworks"
              item-key="name"
              align-center
              color="white">
              <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                medium
                @click="addPackageToNetwork(props.item)"
                color="primary"
              >add_circle_outline</v-icon>
            </template>
            <span>Add package to Network</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center"><v-chip>{{props.item.type}}</v-chip></td>

        <td class="text-xs-center">{{props.item.packagesFnoCat.name}}</td>
        <td class="text-xs-center">{{props.item.packageCode}}</td>
        <td class="text-xs-center">
          {{props.item.speedProfile.downloadMbps}}/
          {{props.item.speedProfile.uploadMbps}} Mbps {{props.item.speedProfile.contentionRatio}}
        </td>
        <td class="text-xs-center">{{props.item.packageBasePrice | currency}}</td>
        <td class="text-xs-center" 
          v-if="props.item.isGlobal"
        ><v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td class="text-xs-center" v-if="props.item.isActive===true">
          <v-chip small :class="`Active white--text caption my-2`">Active</v-chip>
        </td>
        <td class="text-xs-center" v-else>
          <v-chip small :class="`Inactive white--text caption my-2`">Inactive</v-chip>
        </td>
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
      <!-- <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
      </template> -->
      
              </v-data-table>
              
 </v-container>
              
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-flex xs12 sm12 md12>
              <v-btn color="primary" flat @click="addPackageModal=false">Cancel</v-btn>
            </v-flex>
          
        </v-card-actions>
        </v-card-text>
      </v-card>

    </v-dialog>

    
    <v-data-table
      :headers="packagesfnolocationnetworksheaders"
      class="elevation-1"
      :search="search"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="packagesfnolocationnetworks"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
      color="white"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                medium
                @click="deleteItem(props.item)"
                color="red"
              >remove_circle</v-icon>
            </template>
            <span>Remove package from Network</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.packageCode}}</td>
        <td class="text-xs-center">
          {{props.item.packagesFno.speedProfile.downloadMbps}}/
          {{props.item.packagesFno.speedProfile.uploadMbps}} Mbps {{props.item.packagesFno.speedProfile.contentionRatio}}
        </td>
        <td class="text-xs-center">{{props.item.packagesFno.packageBasePrice | currency}}</td>
         <td class="text-xs-center" 
          v-if="props.item.chargeRouterInstallFee"
        ><v-icon @click="changeChargeRouterInstallFee(props.item)" color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon @click="changeChargeRouterInstallFee(props.item)" color="red">not_interested</v-icon>
        </td>
        <td class="text-xs-center" 
          v-if="props.item.packagesFno.isGlobal"
        ><v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td class="text-xs-center" v-if="props.item.packagesFno.isActive===true">
          <v-chip small :class="`Active white--text caption my-2`">Active</v-chip>
        </td>
        <td class="text-xs-center" v-else>
          <v-chip small :class="`Inactive white--text caption my-2`">Inactive</v-chip>
        </td>
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
      <!-- <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
      </template> -->
    </v-data-table>

    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT PACKAGE</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  prepend-icon="edit"
                  label="Speed Profile"
                  :items="speedprofile"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.speedProfileId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                  <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  prepend-icon="edit"
                  label="Package Category"
                  :items="packagesfnocat"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.packagesFnoCatId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center pr-5 pl-3 pt-2"
                  prepend-icon="edit"
                  v-model="editedItem.packageCode"
                  label="Package Code*"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              

              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center pr-5 pl-3 pt-2"
                  prepend-icon="money"
                  v-model="editedItem.packageBasePrice"
                  label="Package Base Price*"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-menu>
                  <v-text-field
                  class="text-xs-center pr-5 pl-3 pt-2"
                    :value="formatDate(this.editedItem.startDate)"
                    slot="activator"
                    label="Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-menu>
                  <v-text-field
                  class="text-xs-center pr-5 pl-3 pt-2"
                    :value="formatDate(this.editedItem.endDate)"
                    slot="activator"
                    label="End Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.endDate"></v-date-picker>
                </v-menu>
              </v-flex>

              
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="save">Save</v-btn>
          </v-layout>
          
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import VueCurrencyFilter from "vue-currency-filter";
import dateformat from "dateformat";
import format from "date-fns/format";
import Api from "@/services/Api";


export default {
  props: ["packagesfnolocationnetworks","packagesfnocat","speedprofile","allpackagesfnolocationnetworks","speedprofiles","packagetypes","packagesfnocats","chosenfnocats","isloading"],
  components: {
    "vue-currency-filter": VueCurrencyFilter
  },

  data() {
    return {
      chargeRouterInstallFee: "",
      loading: false,
      pagination: {},
      dialog: false,
      filterPackages: false,
      packagesInCat:[],
      selectedFnoCat: "",
      packageFno:[],
      chosenFnoCats: [],
      addPackageGroupModal: false,
      filterSpeed: null,
      filterPackageType: null,
      snackbar: false,
      packageBatchNumber: "",
      text: "",
      y: "top",
      addPackageModal: false,
      editedItem: {
        packageCode: "",
        speedProfileId: "",
        packagesFnoCatId: "",
        packageBasePrice: "",
        startDate: "",
        endDate: "",
        isActive: "",
        isDeleted: ""
      },
      fnoPackages: [
        {
          endDate: "",
          isActive: "",
          isDeleted: "",
          isPromotion: "",
          packageBasePrice: "",
          packageCode: "",
          packagesFnoCatId: "",
          packagesFnoLocationNetworkId: "",
          speedProfileId: "",
          startDate: "",
          xeroProductId: ""
        }
      ],
      allpackagesfnolocationnetworksheaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Type",
          align: "center",
          value: "type"
        },
        {
          text: "Package Category",
          align: "center",
          value: "packagesFno.packagesFnoCat.name"
        },
        {
          text: "Package Name",
          align: "center",
          value: "packagesFno.packageCode"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.name"
        },
        {
          text: "Package Price",
          align: "center",
          value: "packagesFno.packageBasePrice"
        },
        {
          text: "Globally Available",
          align: "center",
          value: "isGlobal"
        },
        {
          text: "Active",
          align: "center",
          value: "packagesFno.isActive"
        }
      ], 
       packagesfnolocationnetworksheaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Package Category",
          align: "center",
          value: "packagesFno.packagesFnoCat.name"
        },
        {
          text: "Package Name",
          align: "center",
          value: "packagesFno.packageCode"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.name"
        },
        {
          text: "Package Price",
          align: "center",
          value: "packagesFno.packageBasePrice"
        },
         {
          text: "Charge Router Installation Fee",
          align: "center",
          value: "packagesfnolocationnetworks.chargeRouterInstallFee"
        },
        {
          text: "Globally Available",
          align: "center",
          value: "packagesFno.isGlobal"
        },
        {
          text: "Active",
          align: "center",
          value: "packagesFno.isActive"
        }
      ], 
    }
    
  },
  watch:{
    filterPackages(value){
      const route= {
        name:this.$route.name
      }
      if(value===true){
          route.query={
        fnoSpeedProfileId: this.filterSpeed,
        fnoPackageType: this.filterPackageType}
        this.$router.push(route);
      this.filterPackages=false;
        }
    },
    },
    created(){
      this.initialize();
    },
  methods: {
    initialize(){
      this.getPackages();
    },
    changeChargeRouterInstallFee(item){
      if(this.chargeRouterInstallFee == true){
        this.chargeRouterInstallFee = false
      }else{
        this.chargeRouterInstallFee = true
      }
      Api().put("/packagesFnoLocationNetwork/"+ item.id,{
          chargeRouterInstallFee: this.chargeRouterInstallFee
      }).then(response=>{
        this.$emit('packagesFnoSaved');
      })
      this.$emit('packagesFnoSaved');
    },
    getPackages() {
      this.chosenIspsArray = [];
      this.chosenIsps = [];
      this.chosenFnoCats = [];
      this.packageFnoCatsArrays = [];
      Api()
        .get(
          "/packagesFnoLocationNetwork/showByLocationNetwork/" +
            this.$route.params.locationNetworkId
        )
        .then(response => {
          this.chosenFnoCats = [];
          this.packageFno = response.data;
          if(this.packageFno.length>0){this.fnoPackagesGenerated=true} else {this.fnoPackagesGenerated=false};
          for (var i = 0; i < this.packageFno.length; i++) {
            if (
              !this.packageFnoCatsArrays.includes(
                this.packageFno[i].packagesFno.packagesFnoCatId
              )
            ) {
              this.packageFnoCatsArrays.push(
                this.packageFno[i].packagesFno.packagesFnoCatId
              );
            }
          }
          for (var y = 0; y < this.packageFnoCatsArrays.length; y++) {
            Api()
              .get("/packagesFnoCats/" + this.packageFnoCatsArrays[y])
              .then(response => {
                this.chosenFnoCats.push({
                  name: response.data[0].name,
                  id: response.data[0].id
                });
              });
          }
          for (var i = 0; i < this.packageFno.length; i++) {
            if (this.chosenFnoCats.length !== 0) {
              for (var x = 0; x < this.chosenFnoCats.length; x++) {
                if (
                  !this.packageFnoCatsArrays.includes(
                    response.data[i].packagesFno.packagesFnoCat.id
                  )
                ) {
                  this.chosenFnoCats.push({
                    name: response.data[i].packagesFno.packagesFnoCat.name,
                    id: response.data[i].packagesFno.packagesFnoCat.id
                  });
                }
              }
            } 
          }
        });
    },

    async addPackageToNetwork(item){
      this.packageBatchNumber = Math.floor(Math.random() * 1000000000000) + 1;
      await Api()
      .get('/packagesFnoLocationNetwork/'+this.$route.params.locationNetworkId+'/'+item.id)
      .then(async response=>{
        if(response.data.length===0){
          await Api().post("/packagesFnoLocationNetwork", {
                  packagesFnoId: item.id,
                  locationNetworkId: this.$route.params.locationNetworkId,
                  packageBatchNumber: this.packageBatchNumber.toString()
                }).then(response=>{
                  this.text = "FNO Package Successfully Added to Network!";
                  this.snackbar = true;
                  this.$emit('packagesFnoSaved');
                });
        } else {
          this.text = "FNO Package Already Associated to Network";
          this.snackbar = true;
        }
      });
      this.$emit('packagesFnoSaved');
      this.addPackageModal=false;
      
    },
    // async generateSelectedPackages(networkId) {
    //   console.log(this.chosenFnoCats)
    //   this.packageBatchNumber = Math.floor(Math.random() * 1000000000000) + 1;
    //   for (var i = 0; i < this.chosenFnoCats.length; i++) {
    //     Api()
    //       .get("/packagesFnos/byCategory/" + this.chosenFnoCats[i].id)
    //       .then(async response => {
    //         this.packagesInCat = response.data;
    //         console.log(this.packagesInCat)
    //         for (var y = 0; y < this.packagesInCat.length; y++) {
    //           let exists = false;
    //           console.log(this.packagesfnolocationnetworks.length)
    //           for (var x = 0; x < this.packagesfnolocationnetworks.length; x++) {
    //             if (
    //               this.packagesfnolocationnetworks[x].packagesFno.packagesFnoId === this.packagesInCat[y].id
    //             ) {
    //               exists = true;
    //             } else {
    //             await Api().post("/packagesFnoLocationNetwork", {
    //               packagesFnoId: this.packagesInCat[y].id,
    //               locationNetworkId: this.$route.params.locationNetworkId,
    //               packageBatchNumber: this.packageBatchNumber.toString()
    //             });
    //             }
    //           }
    //           if(this.packagesfnolocationnetworks.length===0){
    //             await Api().post("/packagesFnoLocationNetwork", {
    //               packagesFnoId: this.packagesInCat[y].id,
    //               locationNetworkId: this.$route.params.locationNetworkId,
    //               packageBatchNumber: this.packageBatchNumber.toString()
    //             });
    //           }
              
    //         }
    //       });
    //   }
    //   this.text = "FNO Packages Successfully Generated!";
    //   this.$emit('packagesFnoSaved');
    //   this.snackbar = true;
    // },
    getPackagesByLocationNetwork() {
      Api()
        .get("/packagesFnoLocationNetwork/showByLocationNetwork/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.packageFno = response.data;
        });
    },

    async generateSelectedPackages(networkId) {
      this.packageBatchNumber = Math.floor(Math.random() * 1000000000000) + 1;
      Api()
        .get("/packagesFnos/byCategory/" + this.selectedFnoCat)
        .then(async response => {
          let packagesInCat = response.data
          this.packagesInCat = response.data;
          let allPackages =[]
          let existingPackages =[]
          let post =[]
          for (let b=0; b< packagesInCat.length;b++){
            await allPackages.push(packagesInCat[b].id)
          }
          for (var x = 0; x < this.packagesfnolocationnetworks.length; x++) {
            if(!existingPackages.includes(this.packagesfnolocationnetworks[x].packagesFnoId)){
              await existingPackages.push(this.packagesfnolocationnetworks[x].packagesFnoId)
          }
            }
            for (let a=0; a< allPackages.length;a++){
              if(existingPackages.indexOf(allPackages[a])===-1){
                await post.push({locationNetworkId: networkId, packagesFnoId: allPackages[a], pacakgeBatchNumber: this.packageBatchNumber.toString()})
              }
            }
              await Api().post("/packagesFnoLocationNetwork", {
                batch: post
              });
            this.chosenFnoCats=[];
            this.$emit("packagesFnoSaved");
            this.getPackages();
          this.fnoPackagesGenerated = true;
        });
      this.selectedFnoCat="";
      this.$emit("packagesFnoSaved");
      this.fnoPackagesGenerated = true;
      this.text = "FNO Packages Successfully Generated!";
      this.snackbar = true;
    },
    // async generateSelectedPackages(networkId) {
    //   // await this.getPackages();
    //   this.packageBatchNumber = Math.floor(Math.random() * 1000000000000) + 1;
    //   console.log(this.chosenFnoCats)
    //   for (var i = 0; i < this.chosenFnoCats.length; i++) {
    //     Api()
    //       .get("/packagesFnos/byCategory/" + this.chosenFnoCats[i].id)
    //       .then(async response => {
    //         this.packagesInCat = response.data;
    //         console.log(this.packagesInCat)
    //         for (var y = 0; y < this.packagesInCat.length; y++) {
    //           let exists = false;
    //           for (var x = 0; x < this.packagesfnolocationnetworks.length; x++) {
    //             if (
    //               this.packagesfnolocationnetworks[x].packagesFnoId === this.packagesInCat[y].id
    //             ) {
    //               exists = true;
    //             }
    //           }
    //           if (exists) {
    //           } else {
    //             await Api().post("/packagesFnoLocationNetwork", {
    //               packagesFnoId: this.packagesInCat[y].id,
    //               locationNetworkId: networkId,
    //               packageBatchNumber: this.packageBatchNumber.toString()
    //             }).then(response=>{
    //               console.log("Posted "+response.data[0])
    //             });
    //           }
    //           this.getPackagesByLocationNetwork(networkId);
    //         }
    //       });
    //   };
    //   this.$emit("packagesFnoSaved");
    //   this.fnoPackagesGenerated=true;
    //   this.text = "FNO Packages Successfully Generated!";
    //   this.snackbar = true;
    // },
    addFnoItem(){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.addPackageModal=true
      }
    },
    addFnoGroup(){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.addPackageGroupModal=true
      }
    },
        editItem(item) {
          if(this.authUpdate(this.$store.state.currentRoute)){
          this.editedItem = Object.assign({}, item);
          this.dialog = true;
          }
        },
        deleteItem(item) {
          if(this.authDelete(this.$store.state.currentRoute)){
          confirm("Are you sure you want to remove this package from the network?") &&
            Api().put("/packagesFnoLocationNetwork/" + item.id, {
              isActive: false,
              isDeleted: true
            }).then(async response=>{
              await Api()
              .get('/supplier/ispLocationNetwork/fnoPackageOnNetwork/'+item.packagesFnoId+'/'+this.$route.params.locationNetworkId)
              .then(response=>{
                for (let i=0; i<response.data.length;i++){
                  Api()
                  .put('/supplier/ispLocationNetwork/'+response.data[i].id,{
                    isActive: false,
                    isDeleted: true
                  })
                }
              })
              this.$emit('packagesFnoSaved'), this.$emit("ispPackageAdded")
            });
            this.$emit("ispPackageAdded");
          this.$emit("packagesFnoSaved");
          }
        },
        formatDate(date){
      if (date==null){
        return null} else{
          return dateformat(date,'dd/mm/yyyy')
        }
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
      }
};
</script>
<style>
.v-chip.Active {
  background: #1ebb2c;
}
.v-chip.Inactive {
  background: #f0121e;
}
</style>


